import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-radar-line',
    title: '智能吸金引擎',
    desc: '基于大数据与AI算法，实时扫描市场机会，自动捕捉每一个盈利窗口，让收益像磁铁一样被吸引过来。',
    link: '/category/method',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多重风控保障',
    desc: '智能止损、分散配置、实时监控三重防护，在追求收益的同时守护你的本金安全，风险可控。',
    link: '/category/strategy',
  },
  {
    icon: 'ri-rocket-2-line',
    title: '一键启动策略',
    desc: '无需复杂设置，选择适合你的风险偏好，一键启动智能策略，系统自动完成分析、决策和执行。',
    link: '/category/tutorial',
  },
  {
    icon: 'ri-line-chart-line',
    title: '复利增长模型',
    desc: '收益自动复投机制，让利润持续产生利润，发挥复利的指数增长威力，实现财富的雪球效应。',
    link: '/category/strategy',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全平台覆盖',
    desc: '支持网页端、iOS和Android，数据实时同步，随时随地掌握财富动态，碎片时间也能高效管理。',
    link: '/category/tutorial',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '7×24小时服务',
    desc: '专业客服团队全天候在线支持，旗舰版用户尊享一对一专属顾问，任何问题都能快速解决。',
    link: '/about',
  },
];

export default function Features() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            为什么选择磁力金牛
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto">
            六大核心优势，为你打造专属的智能财富增长体系
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f) => (
            <Link
              key={f.title}
              to={f.link}
              className="group bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {f.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}